import { Module } from 'vuex-smart-module';
import CartHistoryActions from './actions';
import CartHistoryGetters from './getters';
import CartHistoryMutations from './mutations';
import CartHistoryState from './state';

export default new Module({
  state: CartHistoryState,
  mutations: CartHistoryMutations,
  actions: CartHistoryActions,
  getters: CartHistoryGetters,
});
